import { createAction } from "@reduxjs/toolkit";

const actionTypes = {
 	setMerges : createAction("setMerges"),	
}

export default actionTypes